<template>
    <div id="theme-gallery">
        <div id="worksends-page-header" class="tw-mb-3">
            <div class="breadcrumbs" id="breadcrumbs">
                <router-link class="breadcrumb-link" to="/surveys/dashboard">Bookblock HUB Surveys</router-link> &gt;
                <router-link class="breadcrumb-link" to="/surveys/themes/gallery">Theme Gallery</router-link>
            </div>
            <h3>Bookblock HUB Survey Theme Gallery</h3>
            <div v-if="isAdmin" class="ws-button ws-button-admin" @click="onShowCreate">Create New Theme For Gallery</div>
            <div class="category-filter tw-float-right">
                <div class="ws-filter ws-filter-select">
                    <WSSelect v-model="filterByCategory" style="min-width: 150px;" :options="[
                        {id: '', name: 'All Categories'},
                        ...categories
                    ]" text-attr="name" value-attr="id"  />
                </div>
            </div>
        </div>
        <div class="jumbotron tw-p-5 tw-rounded tw-flex tw-justify-between tw-flex-col" v-if="showJumbotron">
            <div class="tw-flex tw-justify-between tw-items-start">
                <h2 class="tw-text-white tw-text-lg">Looking for some inspiration?</h2>
                <a class="hide tw-text-white tw-text-xs" @click="hideJumbotron">Hide</a>
            </div>
            <div class="desc text-white">
                <p>
                    Have a look into our themes gallery
                    to choose from many professionally curated themes made by our UI experts that will fit any purpose.
                </p>
            </div>
        </div>
        <div class="grid themes tw-mt-4">
            <div v-for="theme in themes" :key="theme.id" class="item theme tw-bg-white tw-rounded" @click="goToDetail(theme.id)">
                <div class="tw-rounded tw-flex tw-flex-col tw-items-flex-start">
                    <div class="page-preview page-preview-template">
                        <page-view
                            :page="samplePage"
                            :styles="theme.styles"
                            :editable="false"
                            :readonly="true"
                            view="preview-theme"
                        />
                    </div>
                    <h3 class="tw-font-normal">{{ theme.name }}</h3>
                    <div v-if="theme.category" class="category">{{ theme.category.name }}</div>
                    <div v-if="isAdmin" class="status" :class="(theme.active) ? 'status-active' : 'status-draft'">{{ (theme.active) ? 'Active' : 'Draft' }}</div>
                    <div class="description">
                        <p>{{ theme.description }}</p>
                    </div>
                </div>
                <div class="buttons tw-flex tw-justify-between tw-items-center tw-mt-3">
                    <div v-if="!isAdmin" class="ws-button small ws-button-main" @click.stop="onShowActivate(theme)">Activate</div>
                    <div v-if="isAdmin" class="ws-button small ws-button-admin">Edit Gallery Theme</div>
                    <div v-if="isAdmin && !theme.active" class="ws-button small ws-button-inverted activate" @click.stop="onPublish(theme)">Publish</div>
                    <div v-if="isAdmin && theme.active" class="ws-button small ws-button-inverted deactivate" @click.stop="onUnpublish(theme)">Mark Draft</div>
                </div>
            </div>
        </div>
        <modal v-if="showCreateModal" @close="showCreateModal = false">
            <survey-theme-form gallery-mode @save="onCreateTheme" @cancel="showCreateModal = false"/>
        </modal>
        <modal v-if="themeToActivate" @close="themeToActivate = undefined">
            <survey-theme-form theme-activation :theme="themeToActivate" @save="onActivateTheme" @cancel="themeToActivate = undefined"/>
        </modal>
    </div>
</template>

<script>
import Modal from "@/components/modals/Modal";
import SurveyThemeForm from "@/pages/surveys/SurveyThemeForm";
import PageView from "@/pages/surveys/PageView.vue";
import WSSelect from "@/components/elements/WSSelect.vue";

export default {
    name: 'SurveyThemesGalleryList',
    components: {WSSelect, PageView, Modal, SurveyThemeForm},
    data() {
        return {
            showCreateModal: false,
            filterByCategory: '',
            themeToActivate: undefined,
            jumbotron: true,
        }
    },
    computed: {
        samplePage() {
            return this.$store.state.surveyThemeSamplePage;
        },
        categories() {
            return this.$store.state.surveyThemesGallery.categories
        },
        themes() {
            let themes = this.$store.getters["surveyThemesGallery/orderedList"];
            if (this.filterByCategory) {
                themes = themes.filter(({category_id}) => category_id === this.filterByCategory)
            }
            return themes
        },
        isAdmin() {
            return this.$store.state.currentUser.is_bb_admin;
        },
        showJumbotron() {
            return this.$cookies.get('surveys_themes_gallery_jumbotron_hidden') ? false : this.jumbotron;
        },
    },
    watch: {
        filterByCategory: 'loadThemes'
    },
    created() {
        this.loadThemes();
        this.loadCategories();

    },
    methods: {
        loadCategories: function () {
            this.$store.dispatch('surveyThemesGallery/getCategories')
        },
        loadThemes() {
            this.$store.dispatch('surveyThemesGallery/getList', {category: this.filterByCategory})
        },
        onShowCreate() {
            this.showCreateModal = true;
        },
        async onCreateTheme(theme) {
            try {
                var created = await this.$store.dispatch('surveyThemesGallery/create', theme);
                await this.$router.push({ name: 'surveys-themes-gallery-details', params: { theme_id: created.id }})
                /*if (theme.category_name) {
                    await this.$store.dispatch('surveyThemesGallery/getCategories')
                }*/
            } catch (e) {
                this.notifyStatus(e.response?.statusCode)
                if (e.response.statusCode === 422) {
                    this.$set(this.$root, '$errors', e.response.data.errors)
                }
            }
        },
        async onShowActivate(theme) {
            this.themeToActivate = theme;
        },
        async onActivateTheme(payload) {
            const theme = await this.$store.dispatch('surveyThemes/create', payload);
            return this.$router.push({name: 'surveys-theme-details', params: {theme_id: theme.id}})
        },
        async onPublish(theme) {
            await this.$store.dispatch('surveyThemesGallery/publish', theme);
        },
        async onUnpublish(theme) {
            await this.$store.dispatch('surveyThemesGallery/unpublish', theme);
        },
        goToDetail(id) {
            this.$router.push({ name: 'surveys-themes-gallery-details', params: { theme_id: id }})
        },
        hideJumbotron() {
            this.jumbotron = false;
            this.$cookies.set('surveys_themes_gallery_jumbotron_hidden', true);
        },
    },
}
</script>
